const ɵ0 = (created) => created.startOf('day'), ɵ1 = (created) => undefined, ɵ2 = (created) => created.startOf('week'), ɵ3 = (created) => created.plus({ weeks: 1 }).startOf('week'), ɵ4 = (created) => created.startOf('month'), ɵ5 = (created) => undefined, ɵ6 = (created) => {
    if (created.month % 2 === 0) {
        return created.minus({ months: 1 }).startOf('month');
    }
    return created.startOf('month');
}, ɵ7 = (created) => {
    if (created.month % 2 === 0) {
        return created.plus({ months: 1 }).startOf('month');
    }
    return created.plus({ months: 2 }).startOf('month');
}, ɵ8 = (created) => {
    if (created.month % 3 === 0) {
        return created.minus({ months: 2 }).startOf('month');
    }
    else if (created.month % 3 === 1) {
        return created.startOf('month');
    }
    return created.minus({ months: 1 }).startOf('month');
}, ɵ9 = (created) => {
    if (created.month % 3 === 0) {
        return created.plus({ months: 1 }).startOf('month');
    }
    else if (created.month % 3 === 1) {
        return created.plus({ months: 3 }).startOf('month');
    }
    return created.plus({ months: 2 }).startOf('month');
}, ɵ10 = (created) => created.startOf('year'), ɵ11 = () => undefined;
export const BudgetRanges = {
    daily: {
        scale: 'day',
        since: ɵ0,
        until: ɵ1,
    },
    weekly: {
        scale: 'month',
        since: ɵ2,
        until: ɵ3,
    },
    monthly: {
        scale: 'month',
        since: ɵ4,
        until: ɵ5,
    },
    bimonthly: {
        scale: 'month',
        since: ɵ6,
        until: ɵ7,
    },
    quarterly: {
        scale: 'month',
        since: ɵ8,
        until: ɵ9,
    },
    yearly: {
        scale: 'year',
        since: ɵ10,
        until: ɵ11,
    },
};
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
